'use strict'

import _filter from 'lodash/filter'
import _reject from 'lodash/reject'
import moment from 'moment'

import { BaseView } from '../../../shared/utils/baseComponent'
import template from './user-list.template.pug'

class CustomerUsersController extends BaseView {
  constructor($mdSidenav, $element, SessionService, $mdMedia, $state, $mdDialog) {
    'ngInject'
    super($element)
    Object.assign(this, { $mdSidenav, SessionService, $mdMedia, $state, $mdDialog })

    this.user = this.SessionService.currentUser.user
    this.userGroups = [
      { id: 'OWNER', name: 'Eigentümer' },
      { id: 'ADMIN', name: 'Administratoren' },
      { id: 'REGULAR', name: 'Mitarbeiter' },
      { id: 'PENDING', name: 'Warte auf Bestätigung' },
    ]
    this.groupedUsers = {}
    this.eyeCatcher = require('../../assets/users.svg')
  }

  $onInit() {
    this.tasksites = _reject(this.tasksites, { status: 'NEW' })
  }

  $onChanges(changes) {
    if (changes.users) {
      // group pending users and remove them from users array
      this.groupedUsers['PENDING'] = _filter(this.users, (user) => user.user.status === 'PENDING')
      const remaining = _reject(this.users, (user) => user.user.status === 'PENDING')

      // group remaining
      this.groupedUsers['OWNER'] = _filter(remaining, (user) => user.isOwner(this.customer))
      this.groupedUsers['ADMIN'] = _filter(
        remaining,
        (user) => user.isAdmin(this.customer) && !user.isOwner(this.customer),
      )
      this.groupedUsers['REGULAR'] = _filter(
        remaining,
        (user) => !(user.isOwner(this.customer) || user.isAdmin(this.customer)),
      )
    }
  }

  isMe(user) {
    return user.user.email === this.SessionService.currentUser.user.email
  }

  remainingTime(date) {
    return moment(date).fromNow()
  }

  createUser() {
    const createDialog = this.$mdDialog.createUser({
      locals: {
        customer: this.customer,
        tasksites: this.tasksites,
        users: this.users,
      },
    })

    return this.$mdDialog.show(createDialog)
  }
  editUser(user) {
    const userEditDialog = this.$mdDialog.editUser({
      locals: {
        user: user,
        customer: this.customer,
        tasksites: this.tasksites,
      },
    })

    return this.$mdDialog.show(userEditDialog)
  }
}

export const customerUsersComponent = {
  controller: CustomerUsersController,
  bindings: {
    users: '<',
    customer: '<',
    tasksites: '<',
  },
  template: template(),
}



// WEBPACK FOOTER //
// ./app/users/containers/user-list/user-list.component.js